// extracted by mini-css-extract-plugin
export default {"drawer":"drawer__L40Lh","subtitle":"subtitle__ZQLwf","inner":"inner__8cGlA"};